export default {
    data() {
        return {
            propTypes: [],
        };
    },
    created() {
        this.resizeHandle();
        window.addEventListener('resize', this.resizeHandle);
    },
    destroyed() {
        window.addEventListener('resize', this.resizeHandle);
    },
    methods: {
        resizeHandle() {
            const routeName = this.$route.name;
            if (routeName === 'AppointmentOrderIndex') {
                this.mapFun(this.defaultOptions); // 预约订单特殊处理
            } else if (routeName === 'MaintainRemindIndex') {
                this.mapFun(this.originOptins);
                this.formOptions.forEach((item) => { // 保养线索提醒特殊处理
                    this.mapFun(item);
                });
            } else if (routeName === 'ArriveRemindIndex') {
                this.mapFun([this.pushTime, this.arrivedTime]);
            } else if (routeName === 'SubsidyApplyIndex') {
                this.mapFun([...this.BIZ_TO_AUDIT_Options, ...this.TO_SETTLE_Options, ...this.SETTLED_Options]);
            } else {
                this.mapFun(this.props.options);
            }
        },
        mapFun(arr) {
            if (!arr) return;
            const width = document.body.clientWidth;
            arr.forEach((item) => {
                if (item.type === 'date_range' || item.type === 'numberrange') {
                    item.spanTimes = (width < 1441) ? 2 : 1;
                }
            });
        },
    },
    activated() {
        this.resizeHandle();
        window.addEventListener('resize', this.resizeHandle);
    },
    deactivated() {
        window.removeEventListener('resize', this.resizeHandle);
    },
};
